/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 企業ID
     * @type {number}
     * @memberof Company
     */
    companyId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof Company
     */
    companyName: string;
    /**
     * 業種名
     * @type {string}
     * @memberof Company
     */
    industryName: string;
    /**
     * ロゴ画像URL
     * @type {string}
     * @memberof Company
     */
    logoUrl?: string;
    /**
     * フォロー済みかを表すフラグ
     * @type {boolean}
     * @memberof Company
     */
    isFollowing: boolean;
    /**
     * ブロック済みかを表すフラグ
     * @type {boolean}
     * @memberof Company
     */
    isBlocking: boolean;
    /**
     * フォロー可能かを表すフラグ
     * @type {boolean}
     * @memberof Company
     */
    isAllowFollow: boolean;
    /**
     * 最新プレスリリースの公開日時
     * @type {string}
     * @memberof Company
     */
    lastReleasePublishedDatetime: string | null;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'industryName': json['industry_name'],
        'logoUrl': !exists(json, 'logo_url') ? undefined : json['logo_url'],
        'isFollowing': json['is_following'],
        'isBlocking': json['is_blocking'],
        'isAllowFollow': json['is_allow_follow'],
        'lastReleasePublishedDatetime': json['last_release_published_datetime'],
    };
}

export function CompanyToJSON(value?: Company | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'industry_name': value.industryName,
        'logo_url': value.logoUrl,
        'is_following': value.isFollowing,
        'is_blocking': value.isBlocking,
        'is_allow_follow': value.isAllowFollow,
        'last_release_published_datetime': value.lastReleasePublishedDatetime,
    };
}

